(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('SetEfecsVersionController', SetEfecsVersionController);

    SetEfecsVersionController.$inject = ['$controller','$sce','$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', '$http'];

    function SetEfecsVersionController($controller, $sce, $uibModalInstance, parameters, SoopkitchenUtils, Planning, $http) {

        var vm = this;
        var title = 'Set the E-FECS version and the Prime identifier for Plan <span class="label label-info">' + parameters.label + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController', {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));

        /**** Properties ****/

        vm.efecsVersion = parameters.currentVersion;
        vm.prime = parameters.prime;

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = setEfecsVersion;

        function updateEfecs() {
            Planning.setEfecsVersion(
                {
                    planLabel: parameters.label,
                    efecsVersion: vm.efecsVersion,
                    prime: vm.prime
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');

                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }

        function setEfecsVersion() {
            $http({
                method: 'GET',
                url: 'api/plan/checks/' + parameters.label,
            }).then(function successCallback(response) {
                SoopkitchenUtils.sanityChecksResult(response, updateEfecs, "Click OK to set the EFECS version");
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
            });
        }
    }
})();
